import {useState} from "react";
import {Button, Modal, Spinner} from "react-bootstrap";

interface DeleteConfirmModalProps {
    show: boolean;
    onCancel: () => void;
    onConfirm: () => Promise<void>;
    message?: string;
}

export function DeleteConfirmModal({show, onCancel, onConfirm, message = "この登録されているジョブを削除します。"}: DeleteConfirmModalProps) {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            await onConfirm();
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Modal show={show} onHide={onCancel} centered className="confirm-dialog"
               backdropClassName="modal-backdrop-nested">
            <Modal.Header closeButton>
                <svg width="17" className="me-2" height="17" viewBox="0 0 17 17" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.49996 0.654297C4.15189 0.654297 0.653809 4.15237 0.653809 8.50045C0.653809 12.8485 4.15189 16.3466 8.49996 16.3466C12.848 16.3466 16.3461 12.8485 16.3461 8.50045C16.3461 4.15237 12.848 0.654297 8.49996 0.654297ZM8.49996 4.61007C9.05573 4.61007 9.48073 5.03507 9.48073 5.59084C9.48073 6.1466 9.05573 6.5716 8.49996 6.5716C7.94419 6.5716 7.51919 6.1466 7.51919 5.59084C7.51919 5.03507 7.94419 4.61007 8.49996 4.61007ZM10.1346 11.4755C10.1346 11.6389 10.0038 11.7697 9.80765 11.7697H7.19227C7.02881 11.7697 6.86535 11.6716 6.86535 11.4755V10.8216C6.86535 10.6581 6.99612 10.462 7.19227 10.462C7.35573 10.462 7.51919 10.3639 7.51919 10.1678V8.86007C7.51919 8.6966 7.38842 8.50045 7.19227 8.50045C7.02881 8.50045 6.86535 8.40237 6.86535 8.20622V7.55237C6.86535 7.38891 6.99612 7.19276 7.19227 7.19276H9.15381C9.31727 7.19276 9.48073 7.35622 9.48073 7.55237V10.1678C9.48073 10.3312 9.6115 10.462 9.80765 10.462C9.97112 10.462 10.1346 10.6255 10.1346 10.8216V11.4755Z"
                          fill="#969492"/>
                </svg>
                確認</Modal.Header>
            <Modal.Body>
                <p className="fs-13 mb-0">{message}</p>
                <p className="fs-13">よろしいですか？</p>
            </Modal.Body>
            <Modal.Footer className="modal-footer">
                <Button variant="light" size="sm" className="modal-btn modal-cancel-btn" onClick={onCancel}>
                    キャンセル
                </Button>
                <Button variant="danger" size="sm" className="modal-btn" disabled={isDeleting} onClick={handleConfirm}>
                    {isDeleting ? (
                        <>
                            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true"/>
                            削除...
                        </>
                    ) : (
                        "削除"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
